import {gql} from 'apollo-boost';

export const GET_CLASSMATERIAL = gql`
  query getClassMaterial($id : ID!){
    getClassMaterial (
      id: $id
    ) {
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
    }
  }
`;

export const GET_CLASSMATERIALS_BY_FILTER = gql`

  query getClassMaterialsByFilter($classMaterialFilterInput: ClassMaterialFilterInput){
    getClassMaterialsByFilter (
      classMaterialFilterInput:$classMaterialFilterInput
    ){
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }

    }
  }
`;

export const GET_CLASSMATERIALS = gql`
  query getClassMaterials {
    getClassMaterials {
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
    }
  }
`;

export const ADD_CLASSMATERIAL = gql`
  mutation addClassMaterial(
    $classSectionId: ID!
    $classMaterialInput: ClassMaterialInput!
  ) {
    addClassMaterial(
      classSectionId: $classSectionId
      classMaterialInput: $classMaterialInput
    ) {
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
    }
  }
`;

export const UPDATE_CLASSMATERIAL = gql`
  mutation updateClassMaterial(
    $id: ID!,
    $classMaterialInput: ClassMaterialInput!
#    $file: Upload
  ) {
    updateClassMaterial(
      id: $id
      classMaterialInput: $classMaterialInput
#      file: $file
    ) {
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
    }
  }
`;

export const DELETE_CLASSMATERIAL = gql`
  mutation deleteClassMaterial($id: ID!) {
    deleteClassMaterial(
      id: $id
    ) {
      id sectionNo sequence nameLocal nameEng uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
    }
  }
`;

